import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { env } from '@amfam/environment';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';

export const optimizelyGuard: CanActivateFn = async (): Promise<boolean> => {
  const featureFlag = inject(FeatureFlagService);

  const key = env.optimizelyKey;
  if (!key) return true;
  await featureFlag.initiateOptimizely(env.optimizelyKey);
  return featureFlag.optimizelyClient.onReady().then(() => true);
};
